export const COLOR_SCHOOL_TITLE = 'aliceblue' as const
